import { render, staticRenderFns } from "./order-date-range.vue?vue&type=template&id=d973cff4&scoped=true&"
import script from "./order-date-range.component.ts?vue&type=script&lang=ts&"
export * from "./order-date-range.component.ts?vue&type=script&lang=ts&"
import style0 from "./order-date-range.scss?vue&type=style&index=0&id=d973cff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d973cff4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d973cff4')) {
      api.createRecord('d973cff4', component.options)
    } else {
      api.reload('d973cff4', component.options)
    }
    module.hot.accept("./order-date-range.vue?vue&type=template&id=d973cff4&scoped=true&", function () {
      api.rerender('d973cff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery/components/order-date-range/order-date-range.vue"
export default component.exports